import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import { mainReducer } from '../reducer/mainReducer'
import { styleReducer } from "../reducer/styleReducer"
import { composeWithDevTools } from "redux-devtools-extension"

const reducer = combineReducers({
    main: mainReducer,
    style: styleReducer
})



const store = createStore(reducer, composeWithDevTools(
    applyMiddleware(thunk))
)

export default store
